import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Link } from "react-router-dom";
import UsuarioFindDialog from "../../Usuario/UsuarioFindDialog";
import AlunoTurmasTable from "../../AlunoTurma/Aluno/AlunoTurmasTable";
import AlunoResponsavelTable from "../../AlunoResponsavel/AlunoResponsavelTable";

const TURMAS = "turmas";
const RESPONSAVEIS = "responsaveis";

const AlunoForm = ({ aluno, setAluno, clickSubmit, handleDelete, handleDeleteUsuario, isSaving }) => {
  const [openSearchUsuario, setOpenSearchUsuario] = useState(false);
  const [aba, setAba] = useState(TURMAS);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAluno((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSelectedUsuario = (usuarioAluno) => {
    setAluno((prevState) => ({ ...prevState, usuarioAluno }));
    setOpenSearchUsuario(false);
  };

  return (
    <Stack spacing={3}>
      <UsuarioFindDialog
        openSearchUsuario={openSearchUsuario}
        handleSelectedUsuario={handleSelectedUsuario}
        closeUsuarioSearch={() => setOpenSearchUsuario(false)}
      />

      <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ textTransform: "uppercase" }} mb={2}>
          Dados do aluno
        </Typography>
        <Stack component="form" onSubmit={clickSubmit} spacing={2.5}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 3 }}>
              <TextField
                size="small"
                fullWidth
                label="Código"
                name="codAlunoEscola"
                autoFocus={aluno.eNovo}
                onChange={handleChange}
                value={aluno.codAlunoEscola ?? ""}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 9 }}>
              <TextField
                size="small"
                fullWidth
                required
                label="Nome"
                name="nome"
                onChange={handleChange}
                value={aluno.nome ?? ""}
                slotProps={{ htmlInput: { maxLength: 60 } }}
              />
            </Grid>
          </Grid>

          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              size="small"
              fullWidth
              label="Usuário Aluno"
              placeholder="Nenhum usuário vinculado"
              value={aluno.usuarioAluno?.email ?? ""}
              onClick={() => setOpenSearchUsuario(true)}
              slotProps={{ input: { readOnly: true } }}
            />
            {aluno.usuarioAluno && (
              <Tooltip title="Remover vínculo com o usuário">
                <IconButton onClick={handleDeleteUsuario}>
                  <ClearIcon />
                </IconButton>
              </Tooltip>
            )}
            <Button
              variant="outlined"
              startIcon={<PersonSearchOutlinedIcon />}
              onClick={() => setOpenSearchUsuario(true)}
              sx={{ flexShrink: 0 }}
            >
              Buscar
            </Button>
          </Stack>

          <Stack direction={{ xs: "column-reverse", sm: "row" }} justifyContent="space-between" spacing={1}>
            <Box>
              {!aluno.eNovo && (
                <Button color="error" startIcon={<DeleteOutlineIcon />} onClick={handleDelete} disabled={isSaving}>
                  Remover
                </Button>
              )}
            </Box>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              {!aluno.eNovo && (
                <Button
                  variant="outlined"
                  startIcon={<MenuBookOutlinedIcon />}
                  component={Link}
                  to="/aluno-livro"
                  state={{ aluno }}
                >
                  Livros do Aluno
                </Button>
              )}
              <Button type="submit" variant="contained" startIcon={<SaveOutlinedIcon />} disabled={isSaving}>
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Paper>

      {aluno.codigo && (
        <Paper variant="outlined" sx={{ borderRadius: 2 }}>
          <Tabs value={aba} onChange={(event, value) => setAba(value)} sx={{ px: 1.5, borderBottom: 1, borderColor: "divider" }}>
            <Tab value={TURMAS} label="Turmas" />
            <Tab value={RESPONSAVEIS} label="Responsáveis" />
          </Tabs>
          <Box p={2.5}>
            {aba === TURMAS ? <AlunoTurmasTable aluno={aluno} /> : <AlunoResponsavelTable aluno={aluno} />}
          </Box>
        </Paper>
      )}
    </Stack>
  );
};

export default AlunoForm;
